import React from "react";
import Helmet from "react-helmet";

class JsonLd extends React.Component {
  render() {
    return (
      <Helmet>
        <script type="application/ld+json">{`{
          "@context": "http://schema.org",
          "@type": "Blog",
          "name": "${this.props.title}",
          ${
      this.props.author !== null
        ? `"author": {
                    "@type": "Person",
                    "name": "${this.props.author}"
                  },`
        : ""
      }
          "image":"${this.props.image ? this.props.image.file.url : ""}",
          "description": "${this.props.description.introduction}",
          "datePublished": "${this.props.datePublished}"
          }`}</script>
      </Helmet>
    );
  }
}

export default JsonLd;
